export default __webpack_public_path__ + "static/banner_app_dark-9eaa5e1e7951e830e649b15030b86f05.png";